var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.7307C8 10.5666 10.6301 8 13.8746 8H81.621C84.8654 8 87.4956 10.5666 87.4956 13.7307V82.2693C87.4956 85.4345 84.8654 88 81.621 88H13.8746C10.6301 88 8 85.4345 8 82.2693V13.7307Z",
    fill: "#006699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0975 74.9683V38.8438H20.0904V74.9683H32.0975ZM26.0939 33.9116C30.281 33.9116 32.8872 31.1376 32.8872 27.671C32.8091 24.1263 30.281 21.4293 26.1733 21.4293C22.0661 21.4293 19.3806 24.1263 19.3806 27.671C19.3806 31.1376 21.9862 33.9116 26.0156 33.9116H26.0939Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7415 74.9683H50.7484V54.7948C50.7484 53.7152 50.8265 52.6366 51.1435 51.8648C52.0115 49.7076 53.9872 47.4735 57.3042 47.4735C61.649 47.4735 63.387 50.7862 63.387 55.6425V74.9683H75.393V54.255C75.393 43.1592 69.4694 37.9961 61.5697 37.9961C55.0922 37.9961 52.2485 41.6167 50.6686 44.0828H50.7488V38.8438H38.7418C38.8993 42.2335 38.7415 74.9683 38.7415 74.9683Z",
    fill: "white"
  })));
};
export default SvgLinkedin;